(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 768) {
    const topSwiper = new Swiper('.topBannerSwiper', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
    });

    const bottomSwiper = new Swiper('.bottomBannerSwiper', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
    });

    document.getElementById('topPrevBtn').addEventListener('click', () => {
      topSwiper.slidePrev();
    });

    document.getElementById('topNextBtn').addEventListener('click', () => {
      topSwiper.slideNext();
    });

    document.getElementById('bottomPrevBtn').addEventListener('click', () => {
      bottomSwiper.slidePrev();
    });

    document.getElementById('bottomNextBtn').addEventListener('click', () => {
      bottomSwiper.slideNext();
    });
  }


});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-boom-hugger-cover"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) {
      const topSwiper = new Swiper('.topBannerSwiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
      });
  
      const bottomSwiper = new Swiper('.bottomBannerSwiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
      });
  
      document.getElementById('topPrevBtn').addEventListener('click', () => {
        topSwiper.slidePrev();
      });
  
      document.getElementById('topNextBtn').addEventListener('click', () => {
        topSwiper.slideNext();
      });
  
      document.getElementById('bottomPrevBtn').addEventListener('click', () => {
        bottomSwiper.slidePrev();
      });
  
      document.getElementById('bottomNextBtn').addEventListener('click', () => {
        bottomSwiper.slideNext();
      });
    }
  
  
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-boom-lace-cover"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) {
      const topSwiper = new Swiper('.topBannerSwiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
      });
  
      const bottomSwiper = new Swiper('.bottomBannerSwiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
      });
  
      document.getElementById('topPrevBtn').addEventListener('click', () => {
        topSwiper.slidePrev();
      });
  
      document.getElementById('topNextBtn').addEventListener('click', () => {
        topSwiper.slideNext();
      });
  
      document.getElementById('bottomPrevBtn').addEventListener('click', () => {
        bottomSwiper.slidePrev();
      });
  
      document.getElementById('bottomNextBtn').addEventListener('click', () => {
        bottomSwiper.slideNext();
      });
    }
  
  
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-bras-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ie-bras-hero')) {
    customElements.define('ie-bras-hero', class extends HTMLElement {
      connectedCallback() {
        this.instances = [];
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.rebuild = () => this.build();
        this.motion.addEventListener('change', this.rebuild);
        this.observer = new ResizeObserver(([entry]) => {
          if (entry.contentRect.width === this.lastWidth) return;
          this.lastWidth = entry.contentRect.width;
          this.build();
        });
        this.observer.observe(this);
      }

      destroySliders() {
        this.instances.forEach((swiper) => swiper.destroy(true, true));
        this.instances = [];
        this.querySelectorAll('[data-bras-clone]').forEach((slide) => slide.remove());
      }

      build() {
        this.destroySliders();
        if (typeof Swiper === 'undefined') return;
        this.querySelectorAll('.ie-bras-hero__track').forEach((track) => {
          if (!track.clientWidth) return;
          const wrapper = track.querySelector('.swiper-wrapper');
          // Restore merchant order after Swiper's loop has moved the slides.
          const originals = Array.from(wrapper.children);
          originals.forEach((slide, index) => {
            if (!slide.dataset.brasOrder) slide.dataset.brasOrder = String(index + 1);
          });
          originals.sort((a, b) => Number(a.dataset.brasOrder) - Number(b.dataset.brasOrder));
          originals.forEach((slide) => wrapper.appendChild(slide));
          if (!originals.length) return;
          const step = originals[0].getBoundingClientRect().width;
          // Enough slides for loop mode even with one uploaded packshot or a wide viewport.
          const minimum = Math.ceil(track.clientWidth / step) * 2 + 4;
          for (let index = originals.length; index < minimum; index++) {
            const clone = originals[index % originals.length].cloneNode(true);
            clone.dataset.brasClone = '';
            clone.removeAttribute('data-shopify-editor-block');
            wrapper.appendChild(clone);
          }
          const swiper = new Swiper(track, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            initialSlide: Math.floor(wrapper.children.length / 2),
            centeredSlides: true,
            loop: true,
            speed: Number(this.dataset.speed),
            allowTouchMove: false,
            a11y: false,
            autoplay: {
              enabled: !this.motion.matches,
              delay: 0,
              reverseDirection: track.dataset.row !== '2',
              disableOnInteraction: false,
            },
          });
          this.instances.push(swiper);
        });
      }

      disconnectedCallback() {
        this.observer.disconnect();
        this.motion.removeEventListener('change', this.rebuild);
        this.destroySliders();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-hero-banner-de"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 768) {
    const bottomSwiper = new Swiper('.bottomBannerSwiper', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      autoplay: {
        delay: 3000, // Delay between transitions (in ms)
        disableOnInteraction: false, // Continue autoplay after user interaction
      },
      speed: 500, // Transition speed (in ms)
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-red25"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) {
      const topSwiper = new Swiper('.topBannerSwiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
      });
  
      const bottomSwiper = new Swiper('.bottomBannerSwiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
      });
  
      document.getElementById('topPrevBtn').addEventListener('click', () => {
        topSwiper.slidePrev();
      });
  
      document.getElementById('topNextBtn').addEventListener('click', () => {
        topSwiper.slideNext();
      });
  
      document.getElementById('bottomPrevBtn').addEventListener('click', () => {
        bottomSwiper.slidePrev();
      });
  
      document.getElementById('bottomNextBtn').addEventListener('click', () => {
        bottomSwiper.slideNext();
      });
    }
  
  
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ie-swim25"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) {
      const topSwiper = new Swiper('.topBannerSwiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
      });
  
      const bottomSwiper = new Swiper('.bottomBannerSwiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
      });
  
      document.getElementById('topPrevBtn').addEventListener('click', () => {
        topSwiper.slidePrev();
      });
  
      document.getElementById('topNextBtn').addEventListener('click', () => {
        topSwiper.slideNext();
      });
  
      document.getElementById('bottomPrevBtn').addEventListener('click', () => {
        bottomSwiper.slidePrev();
      });
  
      document.getElementById('bottomNextBtn').addEventListener('click', () => {
        bottomSwiper.slideNext();
      });
    }
  
  
  });
  
  } catch(e) { console.error(e); }
})();
})();
